(function () {
  function variantUnit(option) {
    return option?.dataset?.unit || '';
  }

  function updateCard(card, option) {
    if (!card || !option) return;

    const variantInput = card.querySelector('.product-variant-id');
    const priceEl = card.querySelector('[data-card-price]');
    const unitEl = card.querySelector('[data-card-unit]');
    const submitBtn = card.querySelector('.c-card-product__submit');
    const submitLabel = submitBtn?.querySelector('[data-add-label]');

    if (variantInput) {
      variantInput.value = option.value;
      variantInput.disabled = option.disabled;
    }

    if (priceEl && option.dataset.price) {
      priceEl.textContent = option.dataset.price;
    }

    if (unitEl) {
      const unit = variantUnit(option);
      unitEl.textContent = unit ? `/ ${unit}` : '';
    }

    if (submitBtn) {
      submitBtn.disabled = option.disabled;
    }

    if (submitLabel && option.dataset.price) {
      submitLabel.textContent = `Add to Cart — ${option.dataset.price}`;
    }
  }

  function initCardProducts() {
    document.querySelectorAll('.c-card-product').forEach(function (card) {
      const select = card.querySelector('.c-card-product__variant-select');
      if (select) {
        updateCard(card, select.selectedOptions[0]);
      }
    });
  }

  document.addEventListener('change', function (event) {
    const select = event.target.closest('.c-card-product__variant-select');
    if (!select) return;

    const card = select.closest('.c-card-product');
    updateCard(card, select.selectedOptions[0]);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardProducts);
  } else {
    initCardProducts();
  }
})();
